var registerDOTD = function () {
	const forms = new forms4i();
	const helpers = new formHelpers4i();
	const submitBtn = document.getElementById("registerBtn");
	const registrationForm = document.getElementById("registrationForm");
	const telephoneNumber = document.getElementById("TelNo");
	const mobileNumber = document.getElementById("MobileNo");
	const mask = document.getElementById("PhoneMask");

	const init = () => {
		maskPhones();
		maskZip();

		telephoneNumber.addEventListener("paste", function (e) {
			forms.FixPastedPhoneNumber(e, mask);
		});

		if(mobileNumber)
		{
			mobileNumber.addEventListener("paste", function (e) {
				forms.FixPastedPhoneNumber(e, mask);
			});
		}

		if (registrationForm) forms.BindPasswordButtons(registrationForm)
		if (submitBtn) submitBtn.addEventListener("click", validateForm);
	},
		maskPhones = () => {
			if (mask) {
				forms.MaskPhoneNumber(mask, telephoneNumber);
				forms.MaskPhoneNumber(mask, mobileNumber);
			}
		},
		maskZip = () => {
			const zipMask = document.getElementById("ZipCodeMask");
			if (zipMask) {
				const zipCodeMaskPattern = zipMask.value;
				const zipCode = document.getElementById("ZipCode");
				if (zipCodeMaskPattern != "") VMasker(zipCode).maskPattern(zipCodeMaskPattern);
			}
		},
		validateForm = (e) => {
			e.preventDefault();
			helpers.ClearStatus();
			helpers.ShowBusyBtn(submitBtn);
			submitBtn.setAttribute("disabled", "disabled");
			forms.formValidation(registrationForm, submitRegisterForm, e, enableSubmitBtn);
		},
		submitRegisterForm = () => {
			const recaptchaSiteKey = document.querySelector("#RecaptchaSiteKeyRegister").value;
			const recaptchaActionNameRegister = document.querySelector("#RecaptchaActionNameRegister").value;
			grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionNameRegister }).then(function (token) {
				submitRegisterFormWithRecaptcha(token);
			});
		},
		enableSubmitBtn = () => {
			helpers.ClearBusyBtn();
			submitBtn.removeAttribute("disabled");
		},
		submitRegisterFormWithRecaptcha = (token) => {
			const data = {
				FirstName: document.querySelector("#FirstName").value,
				LastName: document.querySelector("#LastName").value,
				EMailAddress: document.querySelector("#RegisterEMailAddress").value,
				CompanyName: document.querySelector("#CompanyName").value,
				Address1: document.querySelector("#Address1").value,
				Address2: document.querySelector("#Address2").value,
				City: document.querySelector("#City").value,
				State: document.querySelector("#State").value,
				ZipCode: document.querySelector("#ZipCode").value,
				TelNo: document.querySelector("#TelNo").value,
				TelExtension: document.querySelector("#TelExtension").value,
				MobileNo: document.querySelector("#MobileNo").value,
				Subscribe: document.querySelector("#Subscribe").checked,
				IsOrder: document.querySelector("#IsOrder").value == 'true',
				Password: document.querySelector("#RegisterPassword").value,
				RegisterConfirmPassword: document.querySelector("#RegisterConfirmPassword").value,
				RecaptchaActionNameRegister: document.querySelector("#RecaptchaActionNameRegister").value,
				RecaptchaToken: token
			};
			fetch("/dealoftheday/sop/account/Register", {
				method: "POST",
				body: JSON.stringify(data),
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "" }
			}).then(function (response) {
				return (response.ok) ? response.json() : [];
			}).then(function (response) {
				if (response.success) {
					if (window.location.pathname.includes('/dealoftheday/sop/account/register')) {
						window.location.href = response.url;
					} else {
						location.reload();
					}
				} else {
					showError(response);
				}
			}).catch(function (error) {
				console.error(error);
				enableSubmitButton();
				helpers.ShowErrorStatus(submitBtn, "There was an error processing your sign in information. Please try again.");
				return false;
			});
		},
		showError = (response) => {
			enableSubmitBtn();

			if (response.errorType == "Recaptcha" || response.errorType == "Disallowed") {
				submitBtn.insertAdjacentHTML('beforebegin', helpers.ErrorMsgPanel);
				document.getElementById('ErrorTitle').innerHTML = response.title;
				const errorBox = document.getElementById("ErrorMsgBox");
				errorBox.innerHTML = response.message;
				errorBox.focus();
			} else if (response.errorType == "PasswordValidation") {
				let errorList = [];
				response.validationResult.errors.forEach(err => {
					errorList.push(err + "<br />");
				});

				forms.InvalidateField(
					registrationForm,
					document.querySelector('#RegisterPassword'),
					errorList
				);
			} else {
				helpers.ShowErrorStatus(submitBtn.parentNode, response.message);
			}
		};
	return {
		Init: init,
		ValidateForm: validateForm
	};
};

(function () {
	const register = new registerDOTD();
	register.Init();
})();